export const VERSION_COOKIE_KEY = 'tt_web_version'
export const NEW_VERSION = 'new'
export const OLD_VERSION = 'old'
import Cookies from '@arsenal/arsenal/modules/Cookies'

// 如果是客户端环境 依靠cookie 如果是server端则依靠传入的 一般为 req?._isNewVersion
export const isNewVersion = (serverNewVersion?: boolean) => {
  if (typeof window === 'undefined') {
    return !!serverNewVersion
  }
  return Cookies(VERSION_COOKIE_KEY) === NEW_VERSION
}
